(() => {
  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  if (!isEnglish || window.__wuftrekPdpEnFixesLoaded) return;
  window.__wuftrekPdpEnFixesLoaded = true;

  const exactMessages = new Map([
    ['Elige una sola opción para el parche: Nombre o Teléfono.', 'Choose one option for the patch: Name or Phone number.'],
    ['Escribe el nombre que quieres en el parche.', 'Enter the name you want on the patch.'],
    ['Escribe el teléfono que quieres en el parche.', 'Enter the phone number you want on the patch.'],
    ['En Teléfono escribe únicamente un número válido. No incluyas un nombre.', 'For Phone number, enter a valid number only. Do not include a name.'],
    ['En Nombre no incluyas un teléfono. Si quieres poner un número, elige “Teléfono”.', 'For Name, do not enter a phone number. If you want to add a number, choose “Phone number”.'],
    ['Escribe un teléfono de 10 dígitos. Ej. 300 123 4567.', 'Enter a 10-digit phone number. E.g. 300 123 4567.'],
    ['No pudimos cargar el producto Parche personalizado.', "We couldn't load the Personalized Patch product."],
    ['No pudimos agregar el parche personalizado.', "We couldn't add the personalized patch."],
    ['No pudimos agregar la selección.', "We couldn't add your selection."],
  ]);

  const translateMessage = (message) => {
    if (!message) return message;
    if (exactMessages.has(message)) return exactMessages.get(message);

    const nameLimit = message.match(/^El nombre puede tener máximo (\d+) caracteres, incluidos los espacios\.$/);
    if (nameLimit) return `The name can contain up to ${nameLimit[1]} characters, including spaces.`;

    return message;
  };

  const localizePatch = (root) => {
    if (!(root instanceof Element)) return;

    const title = root.querySelector('.wuftrek-patch__title');
    if (title) title.textContent = 'Personalized patch';

    const subtitle = root.querySelector('.wuftrek-patch__subtitle');
    if (subtitle) subtitle.innerHTML = '<strong>Choose one option:</strong> name OR phone number.';

    const mediaPlaceholder = root.querySelector('.wuftrek-patch__media-placeholder');
    if (mediaPlaceholder) mediaPlaceholder.innerHTML = 'PATCH<br>WUFTREK';

    const instruction = root.querySelector('.wuftrek-patch__instruction');
    if (instruction) instruction.textContent = 'What would you like on the patch?';

    const choiceLabel = root.querySelector('.wuftrek-patch__choice-label');
    if (choiceLabel) choiceLabel.textContent = 'Choose one option';

    const radioGroup = root.querySelector('.wuftrek-patch__type-options');
    if (radioGroup) radioGroup.setAttribute('aria-label', 'Personalization type');

    root.querySelectorAll('[data-wuftrek-patch-type]').forEach((radio) => {
      const text = radio.closest('label')?.querySelector('span');
      if (!text) return;
      if (radio.value === 'Nombre') text.textContent = 'Name';
      if (radio.value === 'Teléfono') text.textContent = 'Phone number';
    });

    const selectedType = root.querySelector('[data-wuftrek-patch-type]:checked')?.value || '';
    const input = root.querySelector('[data-wuftrek-patch-text]');
    const inputLabel = root.querySelector('[data-wuftrek-patch-label]');

    if (input && inputLabel) {
      if (selectedType === 'Nombre') {
        inputLabel.textContent = 'Enter the name';
        input.placeholder = 'E.g. MAXI';
      } else if (selectedType === 'Teléfono') {
        inputLabel.textContent = 'Enter the phone number';
        input.placeholder = 'E.g. 300 123 4567';
      } else {
        inputLabel.textContent = 'Choose Name or Phone number';
        input.placeholder = 'First choose an option';
      }
    }

    const help = root.querySelector('.wuftrek-patch__help span:last-child');
    if (help) help.textContent = 'The patch can include a name or phone number, not both.';

    const setupNote = root.querySelector('.wuftrek-patch__setup-note');
    if (setupNote) setupNote.textContent = "We couldn't load the Personalized Patch product.";

    const error = root.querySelector('[data-wuftrek-patch-error]');
    if (error?.textContent) error.textContent = translateMessage(error.textContent.trim());

    const limit = root.querySelector('[data-wuftrek-patch-limit]');
    if (limit && input) {
      if (selectedType === 'Nombre') {
        const count = Array.from(input.value || '').length;
        limit.textContent = `${count}/12 characters`;
      } else if (selectedType === 'Teléfono') {
        const count = (input.value || '').replace(/\D/g, '').length;
        limit.textContent = `${count}/10 digits`;
      }
    }

    root.classList.add('wuftrek-en-ready');
  };

  const localizeCompleteTheSet = (root) => {
    if (!(root instanceof Element)) return;

    const card = root.querySelector('[data-complete-product]');
    const productTitle = card?.dataset.productTitle || '';
    const toggle = root.querySelector('[data-complete-toggle]');
    const imageLink = root.querySelector('.wuftrek-completa-equipo__image-link');
    const availability = root.querySelector('.wuftrek-completa-equipo__availability');

    if (toggle && productTitle) toggle.setAttribute('aria-label', `Add ${productTitle} to cart`);
    if (imageLink && productTitle) imageLink.setAttribute('aria-label', `View ${productTitle}`);
    if (availability?.textContent.trim() === 'Agotado') availability.textContent = 'Sold out';
  };

  const localizeSharedPdpUi = (scope = document) => {
    if (scope.matches?.('wuftrek-personalized-patch')) localizePatch(scope);
    if (scope.matches?.('completa-el-equipo')) localizeCompleteTheSet(scope);

    scope.querySelectorAll?.('wuftrek-personalized-patch').forEach(localizePatch);
    scope.querySelectorAll?.('completa-el-equipo').forEach(localizeCompleteTheSet);

    scope.querySelectorAll?.('[data-complete-buy-now]').forEach((button) => {
      if (button.textContent.trim() === 'Comprar ahora') button.textContent = 'Buy now';
    });

    scope.querySelectorAll?.('.wuftrek-descriptive-badges[aria-label="Etiquetas del producto"]').forEach((item) => {
      item.setAttribute('aria-label', 'Product labels');
    });
  };

  const patchErrorPresenter = (elementName, flagName) => {
    customElements.whenDefined(elementName).then(() => {
      const ElementClass = customElements.get(elementName);
      if (!ElementClass || ElementClass.prototype[flagName]) return;

      const originalShowError = ElementClass.prototype.showError;
      if (typeof originalShowError === 'function') {
        ElementClass.prototype.showError = function showLocalizedError(message) {
          return originalShowError.call(this, translateMessage(message));
        };
      }

      ElementClass.prototype[flagName] = true;
    });
  };

  patchErrorPresenter('wuftrek-personalized-patch', '__wuftrekEnErrorsLocalized');
  patchErrorPresenter('completa-el-equipo', '__wuftrekEnErrorsLocalized');

  const run = () => {
    localizeSharedPdpUi(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (
            node.matches('wuftrek-personalized-patch, completa-el-equipo, [data-complete-buy-now]') ||
            node.querySelector('wuftrek-personalized-patch, completa-el-equipo, [data-complete-buy-now]')
          ) {
            localizeSharedPdpUi(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches('[data-wuftrek-patch-type]')) {
      const root = event.target.closest('wuftrek-personalized-patch');
      window.setTimeout(() => localizePatch(root), 0);
    }
  });

  document.addEventListener('input', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches('[data-wuftrek-patch-text]')) {
      const root = event.target.closest('wuftrek-personalized-patch');
      window.setTimeout(() => localizePatch(root), 0);
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    localizeSharedPdpUi(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
